import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom'
import { Dropdown, IconButton, Menu, MenuButton, MenuItem } from '@mui/joy';
import { DialogContent, DialogTitle, Modal, ModalClose, ModalDialog, ModalOverflow, Avatar, ListDivider } from '@mui/joy';
import { MoreVert } from '@mui/icons-material';
import { useAuth } from '../context/authContext';

import logo from '../resources/logo.svg'

import '../styles/navigation.scss';
import '../styles/typography.scss';
import '../styles/colors.scss';

import ClientManagementComponent from './Client Management/ClientManagementComponent';
import ClientPlanManagementComponent from './Client Management/ClientPlanManagementComponent';
import TeamManagementComponent from './Team Management/TeamManagementComponent';

const helper = require('../Helpers/helpers');
const networking = require('../Networking/AuthenticationAPI');

function PrivateNavigationHeader({ subscription, onSubscriptionUpdate }: any) {
    const { logout, token } = useAuth();

    const [showSettings, setShowSettings] = useState(false);
    const [showTeamManagement, setShowTeamManagement] = useState(false);
    const [showPlanSettings, setShowPlanSettings] = useState(false);
    const [currentUser, setCurrentUser] = useState<any>(null);

    const hasFetched = useRef(false);

    useEffect(() => {
        if (!hasFetched.current) {
            getUserData();
            hasFetched.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function getUserData() {
        networking.getUser(token)
            .then((response: any) => {
                setCurrentUser(response.user);
            })
            .catch((error: any) => {
            });
    }

    function signOut() {
        logout();
    }

    const openCustomerSettings = (event: any) => {
        setShowSettings(true)
    }

    const openTeamSettings = (event: any) => {
        setShowTeamManagement(true)
    }

    const openCustomerPlanSettings = (event: any) => {
        setShowPlanSettings(true)
    }

    const updateSubscription = (subscription: any) => {
        onSubscriptionUpdate(subscription)
    }

    return (
        <div>
            {/* Plan Modal */}
            <Modal
                open={showPlanSettings}
                onClose={() => setShowPlanSettings(false)}>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        size="sm"
                        variant="plain">
                        <ModalClose />
                        <DialogTitle>
                            Plans & Billing
                        </DialogTitle>
                        <DialogContent>
                            Manage your billing and plan settings.
                        </DialogContent>
                        <div className='pt-4'>
                            <ClientPlanManagementComponent
                                subscription={subscription}
                                onSubscriptionUpdate={updateSubscription}
                            />
                        </div>
                    </ModalDialog>
                </ModalOverflow>
            </Modal>
            {/* Settings Modal */}
            <Modal
                open={showSettings}
                onClose={() => setShowSettings(false)}>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        size="sm"
                        variant="plain"
                        minWidth={800}>
                        <ModalClose />
                        <DialogTitle>
                            Profile Settings
                        </DialogTitle>
                        <DialogContent>
                            Here you can update your profile settings.
                        </DialogContent>
                        <div className='pt-4'>
                            <ClientManagementComponent
                                subscription={subscription}
                                onSubscriptionUpdate={updateSubscription}
                            />
                        </div>
                    </ModalDialog>
                </ModalOverflow>
            </Modal>
            {/* Team management Modal */}
            <Modal
                open={showTeamManagement}
                onClose={() => setShowTeamManagement(false)}>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        size="sm"
                        variant="plain"
                        maxWidth={800}>
                        <ModalClose />
                        <DialogTitle>
                            Manage your team
                        </DialogTitle>
                        <DialogContent>
                            Invite Team members and choose which type of access to Appinion they have.
                            Team members can track the same sources as you, or can choose different sources to track.
                            Members can only view and edit their account.
                        </DialogContent>
                        <div className='pt-4'>
                            <TeamManagementComponent
                                subscription={subscription}>
                            </TeamManagementComponent>
                        </div>
                    </ModalDialog>
                </ModalOverflow>
            </Modal>
            <nav className='navbar bg-white navbar-expand-sm'>
                <a href='/' className='navbar-brand'>
                    <img src={logo}
                        height={30 + 'px'}
                        alt='logo'></img>
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                    <ul className='navbar-nav ms-auto'>
                        <li className='nav-item'>
                            <div className='row user-container'>
                                <div className='col text-end'>
                                    <p className='semi-bold iron mb-0'>Hello, {currentUser && currentUser.name}</p>
                                    <p className='legend light-iron mb-0'>{subscription.businessname}</p>
                                </div>
                                <div className='col-auto my-auto'>
                                    {subscription.profileimage &&
                                        <Avatar
                                            alt={subscription.name}
                                            src={subscription.profileimage}>
                                            {helper.getInitials(subscription.businessname)}
                                        </Avatar>
                                    }
                                </div>
                                <div className='col-auto my-auto'>
                                    <Dropdown>
                                        <MenuButton
                                            slots={{ root: IconButton }}
                                            slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
                                        >
                                            <MoreVert />
                                        </MenuButton>
                                        <Menu>
                                            {currentUser && currentUser.role === 'admin' &&
                                                <>
                                                    <MenuItem
                                                        onClick={(e: any) => openCustomerSettings(e)}>
                                                        Profile settings
                                                    </MenuItem>
                                                    {(subscription.status !== 'expired' && subscription.status !== 'trial_expired') &&
                                                        <MenuItem
                                                            onClick={(e: any) => openTeamSettings(e)}>
                                                            Manage Team
                                                        </MenuItem>
                                                    }
                                                    <MenuItem
                                                        onClick={(e: any) => openCustomerPlanSettings(e)}>
                                                        Plans and Billing ⚡️
                                                    </MenuItem>
                                                    <ListDivider />
                                                </>
                                            }
                                            <Link to='/authenticate'>
                                                <MenuItem onClick={signOut}>Sign out</MenuItem>
                                            </Link>
                                        </Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    );
}

export default PrivateNavigationHeader;